import React from 'react';
import { useController } from 'react-hook-form';
import styled from 'styled-components';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { getWidgetProps } from '../common/util/getWidgetProps';
import { IHiddenWidget } from './IHiddenWidget';

const HiddenComponent = styled.div`
  visibility: hidden;
`;

export interface IHiddenWidgetComponentProps
  extends IWidgetComponentProps<IHiddenWidget> {}

export function HiddenWidgetComponent(props: IHiddenWidgetComponentProps) {
  const { widget } = props;

  const options = getWidgetProps(props);

  const { field } = useController({ name: options.name });

  return <HiddenComponent {...field}></HiddenComponent>;
}
